import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  CommandDialog,
  CommandEmpty,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  CommandSeparator,
} from "@/components/ui/command";
import {
  LayoutDashboard,
  Package,
  ShoppingCart,
  Users,
  Settings,
  Search,
  FileText,
  MessageSquare,
  Gift,
  Boxes,
} from "lucide-react";

export function AdminCommandMenu() {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const down = (e: KeyboardEvent) => {
      if (e.key === "k" && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((open) => !open);
      }
    };
    document.addEventListener("keydown", down);
    return () => document.removeEventListener("keydown", down);
  }, []);

  const runCommand = (command: () => void) => {
    setOpen(false);
    command();
  };

  return (
    <>
      <div 
        onClick={() => setOpen(true)}
        className="relative flex items-center px-4 h-10 md:h-12 bg-muted/30 border border-border/50 hover:border-primary/30 rounded-full cursor-pointer group transition-all w-full max-w-md"
      >
        <Search className="h-4 w-4 md:h-5 md:w-5 text-muted-foreground group-hover:text-primary transition-colors" />
        <span className="ml-3 text-xs md:text-sm text-muted-foreground/60 font-medium">
          Search Command center... (⌘K)
        </span>
      </div>

      <CommandDialog open={open} onOpenChange={setOpen}>
        <CommandInput placeholder="Type a command or search..." />
        <CommandList>
          <CommandEmpty>No results found.</CommandEmpty>
          <CommandGroup heading="Navigation">
            <CommandItem onSelect={() => runCommand(() => navigate("/admin"))}>
              <LayoutDashboard className="mr-2 h-4 w-4" />
              <span>Dashboard</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/products"))}>
              <Package className="mr-2 h-4 w-4" />
              <span>Products</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/orders"))}>
              <ShoppingCart className="mr-2 h-4 w-4" />
              <span>Orders</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/customers"))}>
              <Users className="mr-2 h-4 w-4" />
              <span>Customers</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/inventory"))}>
              <Boxes className="mr-2 h-4 w-4" />
              <span>Inventory</span>
            </CommandItem>
          </CommandGroup>
          <CommandSeparator />
          <CommandGroup heading="Engagement">
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/tickets"))}>
              <MessageSquare className="mr-2 h-4 w-4" />
              <span>Support Tickets</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/whatsapp"))}>
              <MessageSquare className="mr-2 h-4 w-4" />
              <span>WhatsApp Broadcasts</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/gift-cards"))}>
              <Gift className="mr-2 h-4 w-4" />
              <span>Gift Cards</span>
            </CommandItem>
          </CommandGroup>
          <CommandSeparator />
          <CommandGroup heading="Settings">
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/settings"))}>
              <Settings className="mr-2 h-4 w-4" />
              <span>Settings</span>
            </CommandItem>
            <CommandItem onSelect={() => runCommand(() => navigate("/admin/audit-logs"))}>
              <FileText className="mr-2 h-4 w-4" />
              <span>Audit Logs</span>
            </CommandItem>
          </CommandGroup>
        </CommandList>
      </CommandDialog>
    </>
  );
}
